export const limitLengthString = (name, limit = 31) => {
  let newName = name.substring(0, limit);
  return name.length <= limit ? newName : newName + ' ...';
};
